package uz.ferro.erp.feature.customer.data

import uz.ferro.erp.api.suspendGet
import uz.ferro.erp.feature.customer.model.SalesPointDto

object SalesRepository {
    suspend fun getSalesPoints(): List<SalesPointDto> {
        return suspendGet("sales/points")
    }
}